import React, { useState, useEffect } from 'react'
import HubspotForm from 'react-hubspot-form'
import useMarketo from '../../hooks/useMarketo'
import { container, header, title, subtitle, formBox } from './index.module.css'

const Form = (props) => {
  const { formId, portalId, loadingText, webinarKey, marketoId, redirect } =
    props.contactForm_ref
  const [loading, setLoading] = useState(true)
  useMarketo({
    baseUrl: '//893-FVD-854.mktoweb.com',
    munchkinId: marketoId,
    formId: formId,
    callback: () => {
      setLoading(false)
    },
    redirect: redirect,
  })
  return marketoId ? (
    <div className="wrapper">
      <section className={[container, 'hubspotForm'].join(' ')}>
        <div className={header}>
          {props.title && <h2 className={title}>{props.title}</h2>}
          {props.subtitle && (
            <div className={subtitle}>
              {props.subtitle.subtitle.split('\n')[0]}
            </div>
          )}
        </div>
        {formId && (
          <>
            <div style={{ display: loading ? 'flex' : 'none' }}>
              {loadingText ? loadingText : 'Loading'}
            </div>

            <form id={`mktoForm_${formId}`} />
          </>
        )}
      </section>
    </div>
  ) : (
    <div className="wrapper">
      <section className={[container, 'hubspotForm'].join(' ')}>
        <div className={header}>
          {props.title && <h2 className={title}>{props.title}</h2>}
          {props.subtitle && (
            <div className={subtitle}>
              {props.subtitle.subtitle.split('\n')[0]}
            </div>
          )}
        </div>
        {formId && portalId && loadingText && (
          <>
            <HubspotForm
              portalId={portalId}
              formId={formId}
              goToWebinarWebinarKey={webinarKey}
              loading={<div>{loadingText}</div>}
            />
            <form
              className={formBox}
              id="ttsForm"
              noValidate
              autoComplete="off"
            />
          </>
        )}
      </section>
    </div>
  )
}

export default Form
